import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/i18n";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// --- PWA: cattura del prompt di installazione e registrazione del service worker ---
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__deferredInstallPrompt = e;
  window.dispatchEvent(new Event("pwa-installable"));
});
window.addEventListener("appinstalled", () => {
  window.__deferredInstallPrompt = null;
  window.dispatchEvent(new Event("pwa-installed"));
});
if ("serviceWorker" in navigator) {
  // Nessun ricaricamento automatico: se arriva una nuova versione, l'utente sceglie quando aggiornare.
  const hadController = !!navigator.serviceWorker.controller;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (!hadController || document.querySelector("[data-testid=update-notice]")) return;
    const lang = (localStorage.getItem("anima_lang") || "it").slice(0, 2);
    const txt = {
      it: ["È disponibile una nuova versione.", "Aggiorna"], en: ["A new version is available.", "Update"],
      fr: ["Une nouvelle version est disponible.", "Mettre à jour"], es: ["Hay una nueva versión disponible.", "Actualizar"],
      de: ["Eine neue Version ist verfügbar.", "Aktualisieren"],
    }[lang] || ["È disponibile una nuova versione.", "Aggiorna"];
    const note = document.createElement("div");
    note.setAttribute("data-testid", "update-notice");
    note.style.cssText = "position:fixed;left:16px;right:16px;bottom:16px;z-index:9999;padding:12px 16px;border-radius:16px;background:#FDFBF7;color:#332F2E;border:1px solid rgba(51,47,46,.15);font:400 15px/1.5 Manrope,sans-serif;display:flex;align-items:center;justify-content:space-between;gap:12px;box-shadow:0 8px 24px rgba(0,0,0,.08)";
    const label = document.createElement("span");
    label.textContent = txt[0];
    const btn = document.createElement("button");
    btn.setAttribute("data-testid", "update-notice-btn");
    btn.textContent = txt[1];
    btn.style.cssText = "border:0;border-radius:999px;padding:8px 16px;background:#61715C;color:#fff;font:500 15px Manrope,sans-serif;cursor:pointer";
    btn.onclick = () => window.location.reload();
    note.append(label, btn);
    document.body.appendChild(note);
  });
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").then((reg) => {
      // Controlla subito e periodicamente la presenza di una nuova versione.
      reg.update().catch(() => {});
      setInterval(() => reg.update().catch(() => {}), 60 * 60 * 1000);
    }).catch(() => {});
  });
}
